import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelope = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.458984 3.67188H19.543V14.9519C19.543 15.302 19.4039 15.6377 19.1564 15.8852C18.9088 16.1328 18.5731 16.2719 18.223 16.2719H1.81898C1.4583 16.2719 1.11238 16.1286 0.857344 15.8735C0.602264 15.6185 0.458984 15.2726 0.458984 14.9119V3.67188ZM1.25898 4.47188V14.9119C1.25898 15.0604 1.31798 15.2028 1.42302 15.3078C1.52802 15.4129 1.67046 15.4719 1.81898 15.4719H18.223C18.3609 15.4719 18.4932 15.4171 18.5907 15.3196C18.6882 15.222 18.743 15.0898 18.743 14.9519V4.47188H1.25898Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.8898 9.63698L1.3966 15.9302L0.839844 15.3557L7.33304 9.0625L7.8898 9.63698Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6058 9.0625L19.139 15.3557L18.584 15.9319L12.0508 9.6387L12.6058 9.0625Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.3862 4.38528L9.98051 11.585L0.615234 4.38476L1.10287 3.75052L9.9816 10.5767L18.8999 3.75L19.3862 4.38528Z"
		})
	]
});
const ForwardRef = forwardRef(SvgEnvelope);
export default ForwardRef;
